import setSweepRuleJsonRequest from 'owa-service/lib/factory/setSweepRuleJsonRequest';
import setSweepRuleOperation from 'owa-service/lib/operation/setSweepRuleOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Helper method that creates the SetSweepRuleJsonRequest body
 * @param sweepRuleId the sweep rule id
 * @param sweepOperation the sweep operation to perform
 * @return SetSweepRuleJsonRequest
 */
function createRequestBody(sweepRuleId, sweepOperation) {
    return setSweepRuleJsonRequest({
        Header: getJsonRequestHeader(),
        Body: { SweepRuleToSet: sweepRuleId, SweepRuleOperation: sweepOperation },
    });
}
/**
 * Set sweep rule service
 * @param sweepRuleId the sweep rule id
 * @param sweepOperation the sweep operation to perform
 * @return SetSweepRuleResponse
 */
export default function setSweepRuleService(sweepRuleId, sweepOperation) {
    var requestBody = createRequestBody(sweepRuleId, sweepOperation);
    return setSweepRuleOperation(requestBody);
}
//# sourceMappingURL=setSweepRuleService.js.map